module.exports = __webpack_public_path__ + "img/super-pass.03555f0a.svg";